<script setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  const props = defineProps({
    forecaster: {
      type: [Object, null],
      required: true
    },
  });

  const { t } = useI18n();

  const forecasterBioUrl = computed(() => props.forecaster ? `https://tempest.earth/forecasters/${props.forecaster.bio_slug}/` : null);

</script>

<template>
  <p v-if="forecasterBioUrl" class="jwx-pro-forecast__credits jwx-font-size-sm">{{ t('containers.proForecast.preparedBy') }} <a :href="forecasterBioUrl" target="_blank" class="jwx-pro-forecast__credits-author">{{ props.forecaster.name }}</a></p>
  <p v-else class="jwx-pro-forecast__credits jwx-font-size-sm">{{ t('containers.proForecast.preparedBy') }} <span class="jwx-pro-forecast__credits-author">{{ props.forecaster?.name }}</span></p>
</template>